export default "__VITE_ASSET__CuVD8ukF__"